module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DSelect', {
    attrs: {
      "items": _vm.itemsWithOccupation,
      "event": _vm.event,
      "isDeleteAllAnOption": _vm.isDeleteAllAnOption,
      "itemsUnselectable": _vm.itemsUnselectable,
      "isLoadingAvailability": _vm.isLoading,
      "isLoading": _vm.isLoadingProp,
      "itemsSelected": _vm.selectedItems,
      "itemsThatCantBeDeleted": _vm.itemsThatCantBeDeleted,
      "multiple": _vm.isMultiple,
      "placeholder": _vm.i18n[_vm.locale]['search'],
      "appendToBody": _vm.appendToBody,
      "calculate-position": _vm.withPopper,
      "show": _vm.show,
      "showCreateButton": _vm.showCreateButton,
      "newUserCalendarId": _vm.newUserCalendarId,
      "disableAddMore": _vm.disableAddMore,
      "isShowCollisions": true
    },
    on: {
      "update": _vm.setSelectedItems,
      "createNew": _vm.createNew,
      "showCalendar": _vm.showCalendar
    }
  }, [(_vm.disableAddMore) ? _c('h4', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [_vm._v(_vm._s(_vm.disableAddMoreMessage))]) : _vm._e()]), _vm._v(" "), (_vm.activeCalendar) ? _c('CalendarViewDay', {
    attrs: {
      "event": _vm.event,
      "date": _vm.date,
      "calendar": _vm.activeCalendar,
      "calendars": _vm.items
    },
    on: {
      "updateAndClose": _vm.updateAndClose,
      "close": function($event) {
        _vm.activeCalendar = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31908e0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectCalendars.vue
// module id = 1839
// module chunks = 1